(function (angular) {
    'use strict';

    angular.module('profiles')
        .component('messageHistory', {
            bindings: {
                calendar: '<',
                profileId: '<',
                devViewEnabled: '<',
                checkIfDisplay: '&',
                batch: '<',
                teamAvatar: '<',
                profileAvatar: '<',
                deleteCallback: '=',
                allowDelete: '='
            },
            controller: ['sharedDataService', '$timeout', '$uibModal', 'messageHistoryService', 'growlService', '$stateParams', '$q', 'messageService', 'comapiChatStore', 'portalConfig', function (sharedDataService, $timeout, $uibModal, messageHistoryService, growlService, $stateParams, $q, messageService, comapiChatStore, portalConfig) {

                var ctrl = this;
                var _calendar;
                var lastFrom;
                var lastTo;

                ctrl.limit = false;
                ctrl.messageHistory = [];
                ctrl.showEllipsis = {};
                ctrl.hideEllipsisButton = function (index) {
                    ctrl.showEllipsis[index] = false;
                };
                ctrl.showEllipsisButton = function (index) {
                    ctrl.showEllipsis[index] = true;
                }

                ctrl.getUsername = function (username) {
                    return sharedDataService.getUsername(username);
                };

                ctrl.scrollTop = function () {
                    $timeout(function () {
                        $('#messageHistory').scrollTop($('#messageHistory')[0].scrollHeight);
                    });
                };

                ctrl.displayMessage = function (id, direction) {
                    if (direction == 'outbound') {
                        $uibModal.open({
                            size: 'lg',
                            animation: true,
                            templateUrl: 'components/toolkit/profiles/templates/messageDetails.html',
                            controller: 'messageDetails',
                            resolve: {
                                message: function () {
                                    return messageHistoryService.getSingleMessage($stateParams.pickedApiSpaceId, id).then(function (result) {
                                        return JSON.stringify(result, undefined, 2);
                                    });
                                }
                            },
                            windowTopClass: 'message-details'
                        });
                    }
                };

                ctrl.getMoreHistory = function (newParams) {
                    var deferred = $q.defer();
                    if (!ctrl.loading && (newParams || !ctrl.limit)) {
                        var from = ctrl.calendar.from.date.toISOString();
                        if (ctrl.messageHistory.length) {
                            from = ctrl.messageHistory[0].submittedOn;
                        }
                        ctrl.loading = true;
                        return messageHistoryService.getHistory($stateParams.pickedApiSpaceId, ctrl.profileId, from, ctrl.batch, !newParams).then(function (result) {
                            if (result.length < ctrl.batch) {
                                ctrl.limit = true;
                            }
                            result.sort(function (a, b) {
                                return (new Date(b.submittedOn)).getTime() - (new Date(a.submittedOn)).getTime();
                            });
                            if (ctrl.calendar.to.date) {
                                for (var message in result) {
                                    if (new Date(result[message].submittedOn) >= ctrl.calendar.to.date) {
                                        ctrl.messageHistory.unshift(result[message]);
                                    }
                                    else {
                                        ctrl.limit = true;
                                        break;
                                    }
                                }
                            }
                            else {
                                for (var message in result) {
                                    ctrl.messageHistory.unshift(result[message]);
                                }
                            }
                            deferred.resolve();
                            ctrl.loading = false;
                        }).catch(function (error) {
                            growlService.danger("Messages wasn't get due to: " + error.statusText);
                            deferred.reject(error);
                        });
                    }
                    else {
                        deferred.reject();
                        ctrl.loading = false;
                    }
                    return deferred.promise;
                };

                ctrl.search = function () {
                    if (ctrl.calendar.from.date != lastFrom || ctrl.calendar.to.date != lastTo) {
                        ctrl.messageHistory = [];
                        ctrl.limit = false;
                    }
                    lastFrom = ctrl.calendar.from.date;
                    lastTo = ctrl.calendar.to.date;
                    ctrl.getMoreHistory(true).then(function (a, b) {
                        ctrl.scrollTop();
                    }).catch(function (error) {
                        console.error(error);
                    });
                };

                ctrl.$doCheck = function () {
                    if (!angular.equals(ctrl.calendar, _calendar)) {
                        if (ctrl.calendar.from.date) {
                            _calendar = angular.copy(ctrl.calendar);
                            ctrl.search();
                        }
                    }
                };

                ctrl.redactMessage = function (message) {

                    messageService.redactMessage($stateParams.pickedApiSpaceId, message.messageId, message.direction)
                        .then(() => {
                            let index = ctrl.messageHistory.findIndex(el => el.messageId === message.messageId);
                            if (index !== -1) {
                                ctrl.messageHistory[index].message.messageParts = [{ type: "text/plain", data: portalConfig.redactedMessageData }];
                                if (message.message && message.message.metadata && message.message.metadata.comapiSystem === "chat") {
                                    return comapiChatStore.updateMessage(message.message.metadata.chatId, message.message.metadata.chatMessageId, [{ type: "text/plain", data: portalConfig.redactedMessageData }]);
                                } else {
                                    //this mean that this is inbound message and we cannot access it that easy so we have to find conversation that have this messageId 
                                    return comapiChatStore.getConversations().then(conversations => {
                                        var conversationsIds = [];
                                        for (var conversation of conversations) {
                                            if (message.channelId === conversation.channelId) {
                                                conversationsIds.push(conversation.id);
                                            }
                                        }
                                        return $q.resolve(conversationsIds);
                                    }).then(conversationsIds => {
                                        var promises = [];
                                        var messageInChat;
                                        var conversationId;
                                        for (var singleConversationId of conversationsIds) {
                                            var promise = comapiChatStore.getMessage(singleConversationId, message.messageId).then((messageExist) => {
                                                if (messageExist) {
                                                    conversationId = singleConversationId;
                                                }
                                                return $q.resolve();
                                            });
                                            promises.push(promise);
                                        }
                                        return $q.all(promises).then(() => $q.resolve(conversationId));
                                    }).then(conversationId => {
                                        if (conversationId) {
                                            return comapiChatStore.updateMessage(conversationId, message.messageId, [{ type: "text/plain", data: portalConfig.redactedMessageData }]);
                                        } else {
                                            return $q.resolve();
                                        }


                                    });
                                }
                            }
                            return Promise.resolve();
                        })
                        .then(() => growlService.success("Message was successfully deleted"))
                        .catch(() => growlService.danger("Message wasn't deleted due to: " + error.statusText));

                };

                ctrl.canShowFcm = function (message) {
                    return message.message.customBody.nativePush.platforms.fcm &&
                        message.message.customBody.nativePush.platforms.fcm.notification &&
                        message.message.customBody.nativePush.platforms.fcm.notification.body;
                };
                ctrl.canShowApns = function (message) {
                    return message.message.customBody.nativePush.platforms.apns &&
                        message.message.customBody.nativePush.platforms.apns.alert;
                }
                ctrl.shouldShowPush = function (message) {
                    return message.channelId == 'nativePush' &&
                        message.message.customBody &&
                        message.message.customBody.nativePush &&
                        message.message.customBody.nativePush.platforms &&
                        (ctrl.canShowFcm(message) || ctrl.canShowApns(message));
                };

                ctrl.$onInit = function () {
                    _calendar = angular.copy(ctrl.calendar);
                    if (!ctrl.checkIfDisplay) {
                        ctrl.checkIfDisplay = function () {
                            return true;
                        }
                    }
                    lastFrom = ctrl.calendar.from.date;
                    ctrl.getMoreHistory().then(function () {
                        ctrl.scrollTop();
                    }).catch(function (error) {
                        console.error(error);
                    });
                }

            }],
            templateUrl: './components/toolkit/profiles/templates/component.messageHistory.html'
        })
})(window.angular);